import { observer } from 'mobx-react';
import { FC, ReactElement } from 'react';
import { localeStore } from 'src/mobx/localesStore';
import Button from 'src/view/components/Controls/ButtonComponent/Button';
import CustomModalComponent from 'src/view/components/Controls/Modal/Modal';
import ModalBackground from 'src/view/components/Controls/Modal/ModalBackground/ModalBackground';
import { modalStore } from '~/mobx/modalStore';
import { IT360SyncErrorsModal } from '~/mobx/modalStore/types';
import ModalFooter from '~/view/components/Controls/Modal/ModalFooter/ModalFooter';
import ModalContent from '~/view/components/Controls/Modal/ModalContent/ModalContent';
import ModalHeader from '~/view/components/Controls/Modal/ModalHeader/ModalHeader';
import { copyToBuffer } from '~/utils/helpers';
import { ButtonAppearance, ButtonSize } from '~/view/components/Controls/ButtonComponent/types';
import './style.scss';

export const T360LastSyncErrorsModal: FC<IT360SyncErrorsModal> = observer((): ReactElement => {
  const closeHandler = () => {
    modalStore.closeT360SyncErrorsModal();
  };

  const onCopy = () => {
    copyToBuffer(JSON.stringify(modalStore.t360SyncErrorsModal?.syncErrors, null, 2));
  };

  return (
    <CustomModalComponent
      isOpen={Boolean(modalStore.t360SyncErrorsModal)}
      onRequestClose={closeHandler}
      withCloseIcon
      className="t360-screen-error-modal"
    >
      <ModalBackground>
        <ModalHeader title={localeStore.t('details')} />
        <ModalContent>
          <div className="order-techlog-item__log family-regilar text-size-14 bg-white p-2 mt-1 mx-2 mb-2">
            {modalStore.t360SyncErrorsModal?.syncErrors ? JSON.stringify(modalStore.t360SyncErrorsModal?.syncErrors, null, 2) : null}
          </div>
        </ModalContent>
        <ModalFooter>
          <Button
            title={localeStore.t('copy')}
            appearance={ButtonAppearance.SECONDARY}
            onClick={onCopy}
            size={ButtonSize.LARGE}
            className="t360-screen-error-modal-copy-button"
          />
        </ModalFooter>
      </ModalBackground>
    </CustomModalComponent>
  );
});
